import { ModelService } from 'src/app/core/services/model.service';
import { ReturnCodes } from 'src/app/pages/change-password/ReturnCodes';
import { HttpErrorResponse } from '@angular/common/http';
import { MiniStorageService } from 'src/app/core/services/mini-storage.service';
import { Router } from '@angular/router';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { AuthorizationProperties } from 'src/app/authentication/auth-info';
import { TranslatedVariables } from 'src/app/commons/translated-variables';
import { CmsService } from 'src/app/core/services/cms.service';
import { CmsObject } from 'src/app/model/cmsobject';
import { AppSubscription } from 'src/app/model/subscription';
import { LoadingService } from 'src/app/core/services/loading.service';
import { YesNoDialogComponent } from 'src/app/store/dialogs/yes-no-dialog/yes-no-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { LoginService } from 'src/app/core/services/login.service';
import { WorkFlowService } from 'src/app/core/services/work-flow.service';
import { SubscriptionService } from 'src/app/core/services/subscription.service';
import { StoreRolesService } from 'src/app/core/services/store-role.service';

@Component({
    selector: 'ms-import-export-home',
    templateUrl: './import-export-home.component.html',
    styleUrls: ['./import-export-home.component.scss'],
})
export class ImportExportHomeComponent implements OnInit {
    public mng_impexp_title: string;
    public mng_impexp_descri: string;
    public cmsObj: CmsObject[];
    //isInternal: boolean = false;
    language: string;
    hasItems: boolean;

    searchSubscription: string = '';
    dataSourceSubscription: MatTableDataSource<AppSubscription>;
    _paginatorSubscriptions: MatPaginator;
    @ViewChild(MatSort) subscriptionsSort: MatSort;

    public loading: boolean = false;

    displayedColumnsSubscriptions: string[] = ['Description', 'SubscriptionKey', 'Actions'];
    //TODOROBY: TRADURRE NOME COLONNE

    @ViewChild('subscriptionsPaginator') set paginatorSubscriptions(contentAccounts: MatPaginator) {
        if (contentAccounts) {
            this._paginatorSubscriptions = contentAccounts;
            const paginatorIntl = this._paginatorSubscriptions._intl;
            paginatorIntl.nextPageLabel = this.variable.nextPage;
            paginatorIntl.previousPageLabel = this.variable.previousPage;
            if (this.dataSourceSubscription) {
                this.dataSourceSubscription.paginator = this._paginatorSubscriptions;
            }
        }
    }
    authorizationStored = this.loginService.getauthinfo();
    authorizationProperties: AuthorizationProperties = JSON.parse(this.authorizationStored);
    listOfSubscriptions: AppSubscription[];
    subscriptionFound: boolean = true;
    previousSubscription: string;
    subKeySelected: string;

    constructor(
        private modelService: ModelService,
        private subscriptionService: SubscriptionService,
        private variable: TranslatedVariables,
        private loginService: LoginService,
        public storeRoleService: StoreRolesService,
        public cmsService: CmsService,
        private miniStorage: MiniStorageService,
        private workFlow: WorkFlowService,
        private router: Router,
        public loadingService: LoadingService,
        private dialog: MatDialog
    ) {
        this.dataSourceSubscription = new MatTableDataSource<AppSubscription>();
    }

    async ngOnInit() {
        await this.getCmsObj();

        await this.getSubscriptions();
        const authorizationStored = this.loginService.getauthinfo();

        if (authorizationStored === null || authorizationStored === undefined) {
            alert('DatabaseHomeComponent: User must be logged in.');
            return;
        }
        this.authorizationProperties = JSON.parse(authorizationStored);
    }

    // -----------------------------------------------------------------------------
    async getSubscriptions() {
        this.loading = true;
        this.loadingService.setLoading(this.loading);

        this.subscriptionService.getSubscriptions4ImpExp(this.authorizationProperties.accountName).subscribe(
            (opRes) => {
                if (!opRes['Result']) {
                    this.workFlow.showMessage(this.variable.errorTitle, opRes['Message']);
                    this.hasItems = false;
                    this.loading = false;
                    this.loadingService.setLoading(this.loading);
                    return;
                }
                this.hasItems = true;
                this.listOfSubscriptions = opRes['Content'];
                this.previousSubscription = this.subKeySelected;

                this.loading = false;
                this.loadingService.setLoading(this.loading);

                // this.listOfSubscriptions.filter((x) => x.SubscriptionKey === this.subKeySelected).map((x) => (x.IsClicked = true));
                this.dataSourceSubscription.data = this.listOfSubscriptions;
                this.dataSourceSubscription.paginator = this._paginatorSubscriptions;
                this.dataSourceSubscription.sort = this.subscriptionsSort;
            },
            (error: HttpErrorResponse) => {
                alert(error.message);

                this.loading = false;
                this.loadingService.setLoading(this.loading);
            }
        );
    }

    // -----------------------------------------------------------------------------
    applyFilterSubscriptions(event: any) {
        let filterValue: string;
        if (event.target) {
            filterValue = (event.target as HTMLInputElement).value;
        } else {
            filterValue = event;
        }
        this.dataSourceSubscription.filterPredicate = function (data, filter: string): boolean {
            return data.Description.toLowerCase().includes(filter) || data.SubscriptionKey.toLowerCase().includes(filter);
        };
        this.dataSourceSubscription.filter = filterValue.trim().toLowerCase();
        if (this.dataSourceSubscription.paginator) {
            this.dataSourceSubscription.paginator.firstPage();
        }
        if (this.dataSourceSubscription.filteredData.length === 0) {
            this.subscriptionFound = false;
        } else {
            this.subscriptionFound = true;
        }
    }

    // -----------------------------------------------------------------------------
    clearSubscriptionSearch() {
        this.searchSubscription = '';
        this.dataSourceSubscription.filterPredicate = function (data, filter: string): boolean {
            return data.Description.toLowerCase().includes(filter) || data.SubscriptionKey.toLowerCase().includes(filter);
        };
        this.dataSourceSubscription.filter = this.searchSubscription.trim().toLowerCase();
        this.subscriptionFound = true;
    }

    // -----------------------------------------------------------------------------
    changeBackground(row: any) {
        // this.listOfSubscriptions.filter((x) => x.SubscriptionKey === this.previousSubscription).map((x) => (x.IsClicked = false));
        // this.listOfSubscriptions.filter((x) => x.SubscriptionKey === row.SubscriptionKey).map((x) => (x.IsClicked = true));
        this.previousSubscription = this.listOfSubscriptions.filter((x) => x.SubscriptionKey === row.SubscriptionKey)[0]?.SubscriptionKey;
        return;
    }

    // -----------------------------------------------------------------------------
    async getCmsObj() {
        this.language = this.workFlow.getLanguageForCms();
        //recupero le stringhe della pagina
        this.cmsObj = await this.cmsService.getCmsObj(this.language, 'accountcomponent');
        this.mng_impexp_title = this.cmsObj.find((x) => x.ContentName == 'accountcomponent.mng_impexp_title').ContentTranslation;
        this.mng_impexp_descri = this.cmsObj.find((x) => x.ContentName == 'accountcomponent.mng_impexp_descri').ContentTranslation;
    }

    // -----------------------------------------------------------------------------
    async setSubKeyAndGo(row: AppSubscription, operation: string) {
        this.loading = true;
        this.loadingService.setLoading(this.loading);
        let isImport = operation === 'import';
        this.modelService.TestConnectAndGetUserLogins(row.SubscriptionKey).subscribe(
            (opRes) => {
                if (!opRes['Result']) {
                    switch (opRes.Code) {
                        case ReturnCodes.NoInstancesAvailable_74:
                            this.workFlow.showMessage(
                                this.variable.errorTitle,
                                this.variable.NoInstancesAvailable + '"' + row.Description + '"'
                            );
                            break;
                        case ReturnCodes.NoSubscriptionDatabasesAvailable_80:
                            this.workFlow.showMessage(
                                this.variable.errorTitle,
                                this.variable.NoSubscriptionDatabasesAvailable + '"' + row.Description + '"'
                            );
                            break;
                        case ReturnCodes.DbUnderMaintenance_101:
                            this.workFlow.showMessage(
                                this.variable.errorTitle,
                                this.variable.DbUnderMaintenance + '"' + row.Description + '"'
                            );
                            break;
                        default:
                            this.workFlow.showMessage(this.variable.errorTitle, opRes['Message'] + ' (' + row.Description + ')');

                            break;
                    }
                    this.loading = false;
                    this.loadingService.setLoading(this.loading);
                    return;
                }
                let y: number = opRes['Content'].length;
                if (y > 0) {
                    let mex = this.variable.dialogSubTitle_4_first + '"' + row.Description + '"';
                    mex += isImport ? this.variable.imp_exp_connUser_imp : this.variable.imp_exp_connUser_exp;
                    mex += this.variable.imp_exp_connUser_you_sure;
                    const dlgAsk = this.dialog.open(YesNoDialogComponent, {
                        data: {
                            Title: this.variable.imp_exp_connUser_title,
                            Message: mex,
                            Result: true,
                        },
                    });

                    dlgAsk.afterClosed().subscribe((resAskDlg) => {
                        if (!resAskDlg || !resAskDlg['Result']) {
                            this.loading = false;
                            this.loadingService.setLoading(this.loading);
                            return;
                        }

                        this.directionsImpExpAndHist(row, operation);
                    });
                } else {
                    this.directionsImpExpAndHist(row, operation);
                }
            },
            (error: HttpErrorResponse) => {
                alert(error.message);

                this.loading = false;
                this.loadingService.setLoading(this.loading);
            }
        );
    }

    // -----------------------------------------------------------------------------
    async directionsImpExpAndHist(row: AppSubscription, operation: string) {
        this.miniStorage.set('imp-subkey-' + row.SubscriptionKey, row, 15);
        if (operation === 'import') {
            this.router.navigate(['/import-export-home/import-management'], {
                queryParams: { subKeySelected: row.SubscriptionKey },
                skipLocationChange: true,
            });
        } else if (operation === 'export') {
            this.router.navigate(['/import-export-home/export-management'], {
                queryParams: { subKeySelected: row.SubscriptionKey },
                skipLocationChange: true,
            });
        } else if (operation === 'history') {
            this.router.navigate(['/import-export-home/history-imp-exp'], {
                queryParams: { subKeySelected: row.SubscriptionKey },
                //  skipLocationChange: true,
            });
        }
        this.loading = false;
        this.loadingService.setLoading(this.loading);
    }
}
